import { render, staticRenderFns } from "./checkManagement.vue?vue&type=template&id=c02c45c6&scoped=true&"
import script from "./checkManagement.vue?vue&type=script&lang=js&"
export * from "./checkManagement.vue?vue&type=script&lang=js&"
import style0 from "./checkManagement.vue?vue&type=style&index=0&id=c02c45c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02c45c6",
  null
  
)

export default component.exports